import { createSelector } from '@ngrx/store';

import * as fromReleaseNotes from './release-note.reducer';
import { selectDashboardState } from '../dashboard.selectors';

export const selectReleaseNotesState = createSelector(selectDashboardState, (dashboard) => dashboard?.releaseNotes);

export const selectReleaseNotes = createSelector(selectReleaseNotesState, fromReleaseNotes.selectAll);

export const selectIsReleaseNotesLoaded = createSelector(
  selectReleaseNotesState,
  (releaseNotesState) => releaseNotesState?.releasesLoaded
);

export const selectLatestRelease = createSelector(selectReleaseNotes, (releaseNotes) =>
  releaseNotes ? releaseNotes[0]?.title : ''
);
